import { render, staticRenderFns } from "./testate.vue?vue&type=template&id=5e79b40a"
import script from "./testate.vue?vue&type=script&lang=js"
export * from "./testate.vue?vue&type=script&lang=js"
import style0 from "./testate.vue?vue&type=style&index=0&id=5e79b40a&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports